import styled from 'styled-components';
import Card from './Card';
import { colorSchema, media } from 'utils/style';

export default styled(Card)`
  .card {
    align-items: stretch;
    background: ${colorSchema('white')};
    border: 1px solid ${colorSchema('greyMouse')};
    cursor: ${props => (props.handleClick ? 'pointer' : 'auto')};
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    padding: 1.6rem;
    width: 100%;

    ${media.greaterThan('tablet')`
      flex-wrap: nowrap;
    `}

    &__body {
      flex-grow: 1;
    }

    &__header {
      ${media.greaterThan('tablet')`
        border-right: 1px solid ${colorSchema('grey300')};
        margin-right: 1.6rem;
        padding-right: 1.6rem;
      `}
    }

    &__footer {
      ${media.greaterThan('tablet')`
        border-left: 1px solid ${colorSchema('grey300')};
        margin-left: 1.6rem;
        padding-left: 1.6rem;
      `}
    }
  }
`;
